import dayjs from 'dayjs';
import { numberFormatter } from '../../utilities/numberFormatter';

interface OptionsChart {
  xTickRotation: number;
  data?: any[];
}

export const options = (params?: OptionsChart): any => {
  return {
    mantainAspectRatio: false,
    plugins: {
      legend: {
        display: false
      },
      datalabels: {
        backgroundColor: (context: any) => {
          return '#fff';
        },
        borderRadius: 2,
        color: '#333',
        padding: 2,
        display: true,
        anchor: 'center',
        align: 'end',
        formatter: (value, context) => numberFormatter(value)
      },
      tooltip: {
        callbacks: {
          label: function (context) {
            let label = context.dataset.label || '';

            if (label) {
              label += ': ';
            }
            if (context.parsed.y !== null) {
              label += numberFormatter(context.parsed.y);
            }
            return label;
          },
          title: function (context) {
            if (params?.data) {
              return params.data[context[0].dataIndex].label
                ? params.data[context[0].dataIndex].label.split(',').join(' ')
                : params.data[context[0].dataIndex]?.month
                ? dayjs()
                    .month(Number(params.data[context[0].dataIndex]?.month) - 1)
                    .format('MMMM')
                : '-';
            }
            return context[0].label
              ? context[0].label.split(',').join(' ')
              : '-';
          }
        }
      }
    },
    scales: {
      x: {
        grid: {
          display: false
        },
        ...(params?.xTickRotation
          ? {
              ticks: {
                autoSkip: false,
                maxRotation: params.xTickRotation,
                minRotation: params.xTickRotation
              }
            }
          : null)
      },
      y: {
        min: 0,
        grid: {
          display: true
        },
        ticks: {
          callback: function (value, index, values) {
            // Format the value as you want
            return value.toLocaleString('id-ID'); // Formats the value as a string with a thousands separator
          }
        }
      }
    }
  };
};

export const optionsLine = (params?: OptionsChart): any => {
  return {
    mantainAspectRatio: false,
    plugins: {
      legend: {
        display: false
      },
      datalabels: {
        backgroundColor: (context: any) => {
          return '#fff';
        },
        borderRadius: 2,
        color: '#333',
        padding: 2,
        display: true,
        anchor: 'center',
        align: 'center',
        formatter: (value, context) => value.toLocaleString('id-ID')
      },
      tooltip: {
        callbacks: {
          label: function (context) {
            let label = context.dataset.label || '';

            if (label) {
              label += ': ';
            }
            if (context.parsed.y !== null) {
              label += context.parsed.y.toLocaleString('id-ID');
            }
            return label;
          },
          title: function (context) {
            return context[0].label
              ? context[0].label.split(',').join(' ')
              : '-';
          }
        }
      }
    },
    scales: {
      x: {
        grid: {
          display: false
        },
        ...(params?.xTickRotation
          ? {
              ticks: {
                autoSkip: false,
                maxRotation: params.xTickRotation,
                minRotation: params.xTickRotation
              }
            }
          : null)
      },
      y: {
        min: 0,
        grid: {
          display: true
        },
        ticks: {
          callback: function (value, index, values) {
            // Format the value as you want
            return value.toLocaleString('id-ID'); // Formats the value as a string with a thousands separator
          }
        }
      }
    }
  };
};
